export default __webpack_public_path__ + "static/media/stop-audio.bf46d06d.svg";